<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Statystyki kostek i wysyłki</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Statystyki kostek i wysyłki</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight logs">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isFiltersOpen = !isFiltersOpen">
            <h5>Filtry</h5>
            <span class="ibox-toggle">
              <i :class="chevronFiltersClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isFiltersOpen">
            <div class="row">
              <div class="col-md-3 nopadding">
                <div class="form-group">
                  <label class="control-label col-sm-3">Wybierz daty</label>
                  <div class="col-sm-8">
                    <VueDatePicker
                      class="stats-daterangepicker2"
                      v-model="filterRangeDate"
                      multi-calendars
                      :format="formatRange"
                      range
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isStatsOpen = !isStatsOpen">
            <h5>Statystyki</h5>
            <span class="ibox-toggle">
              <i :class="chevronStatsClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isStatsOpen">
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :loading="loading"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";

export default {
  name: "CubelogsList",
  mixins: [],
  components: {},
  props: {},

  setup() {
    const store = useStore();
    const productionStatsData = computed(
      () => store.getters.getProductionStatsData
    );
    const chevronFiltersClass = computed(() =>
      isFiltersOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronStatsClass = computed(() =>
      isStatsOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    let headers = [
      { text: "ID", value: "pk" },
      { text: "Użytkownik", value: "name", sortable: true, search: true },
      {
        text: "Liczba produktów",
        value: "order_products_count",
        sortable: true,
      },
      {
        text: "Waga produktów",
        value: "order_products_weight",
        sortable: true,
      },
      {
        text: "Zapakowanych paczek",
        value: "packed_count",
        sortable: true,
      },
      {
        text: "Waga zapakowanych",
        value: "packed_count",
        sortable: true,
      },
      {
        text: "Wysłanych paczek",
        value: "sent_count",
        sortable: true,
      },
      {
        text: "Niewysłanych paczek",
        value: "not_sent_count",
        sortable: true,
      },
    ];
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const filterRangeDate = ref([]);
    const isFiltersOpen = ref(true);
    const isStatsOpen = ref(true);
    const rowsPerPage = ref();
    const filtersMonth = ref();
    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
    });
    let items = ref([]);
    let itemsAll = ref(0);
    const getProductionStats = () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      store.dispatch("getProductionStats", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
        date: filterRangeDate.value,
      });
    };

    const format = (date) => {
      let month, year;
      month = ("0" + (date.getMonth() + 1)).slice(-2);
      year = date.getFullYear();
      return `${month}.${year}`;
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getProductionStats();
          isSearch.value = false;
        }, 1000);
      }
    };

    const updateSort = () => {
      search.value = true;
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const resetFilters = () => {
      searchValue.value = {};
      filterRangeDate.value = [];
      serverOptions.value.sortBy = "";
      getProductionStats();
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("scubeSearchValue") !== null) {
        searchValue.value = localStorage.getItem("scubeSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      if (
        localStorage.getItem("cLogsRangeDate") !== null &&
        localStorage.getItem("cLogsRangeDate") !== undefined &&
        localStorage.getItem("cLogsRangeDate") !== "undefined"
      ) {
        filterRangeDate.value = localStorage.getItem("cLogsRangeDate");
        filterRangeDate.value = JSON.parse(filterRangeDate.value);
      }

      getProductionStats();
    });

    watch(
      () => [searchValue.value, filterRangeDate.value],
      function () {
        localStorage.setItem(
          "scubeSearchValue",
          JSON.stringify(searchValue.value)
        );
        localStorage.setItem(
          "cLogsRangeDate",
          JSON.stringify(filterRangeDate.value)
        );
        getProductionStats();
      }
    );

    watch(
      () => productionStatsData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        getProductionStats();
      }
    );
    watch(
      () => filtersMonth.value,
      function () {
        getProductionStats();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getProductionStats();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      headers,
      serverOptions,
      items,
      itemsAll,
      loading,
      format,
      searchValue,
      search,
      updateSort,
      isSearch,
      rowsPerPage,
      filtersMonth,
      selectPage,
      setRowsPerPage,
      resetFilters,
      filterRangeDate,
      isFiltersOpen,
      isStatsOpen,
      chevronFiltersClass,
      chevronStatsClass,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}

.ibox-toggle:hover {
  color: #333;
}
</style>
